import React, {PureComponent, Fragment} from "react"
import PropTypes from "prop-types"
import {Row, Col} from "react-bootstrap"
import styled from "styled-components"

import id from "@irati/utils/id"
import Loading from "@irati/ui/src/Loading"
import DEAL_PAGES from "@irati-web/perks/src/constants/dealPage"
import authentication from "@irati/auth"
import Hr from "@irati/ui/src/Layout/Hr"
import connect from "@irati/store/connect"

import SearchError from "./SearchError"
import SearchTermValidationError from "./SearchTermValidationError"
import Deals from "../../components/SearchAllResults/Deals"
import SearchInput from "../../components/SearchInput/SearchInput"
import withSearch from "../withSearch"
import SearchAllByLocationCTA from "../../components/SearchAllByLocationCTA/SearchAllByLocationCTA"

const Container = styled.div`
  margin-top: 40px;
`

const StyledSearchInput = styled(SearchInput)`
  margin-bottom: 40px;
`

class SearchAll extends PureComponent {
  static propTypes = {
    search: PropTypes.object.isRequired,
    retryLastSearch: PropTypes.func.isRequired,
    handleNewSearchTermEntry: PropTypes.func.isRequired,
    isValidSearchTerm: PropTypes.bool.isRequired,
    searchTerm: PropTypes.string.isRequired,
    isMobile: PropTypes.bool.isRequired
  }

  static defaultProps = {
    search: {}
  }

  handleInput = (searchTerm) => {
    this.props.handleNewSearchTermEntry(searchTerm)
  }

  render() {
    const idNamespace = id("search-all", this.props, {force: true})
    const {isValidSearchTerm, searchTerm, search, isMobile} = this.props
    const {load, results} = search
    const {deals = []} = results || {}

    const searchAllByLocationCTAWrapper = (
      <Fragment>
        <SearchAllByLocationCTA searchTerm={searchTerm} />
        {isMobile && <Hr />}
      </Fragment>
    )

    return (
      <Container>
        <Row>
          <Col md={12}>
            <StyledSearchInput
              shouldFocusOnNavSearchClick
              id={idNamespace}
              value={searchTerm}
              onChange={this.handleInput} />

            {searchTerm && !isValidSearchTerm && <SearchTermValidationError id={idNamespace} />}

            {isValidSearchTerm && (
              <Loading
                id={idNamespace}
                load={load}
                Error={() => <SearchError id={idNamespace} retryLastSearch={this.props.retryLastSearch} />}>
                {(searchTerm && deals.length > 0 && authentication.apps("platform.geoLocation")) && searchAllByLocationCTAWrapper}
                <Deals id={idNamespace} deals={deals} page={DEAL_PAGES.SEARCH} />
              </Loading>
            )}

          </Col>
        </Row>
      </Container>
    )
  }
}

const mapStateToProps = ({mq}) => ({isMobile: mq.lessThan.sm})

export default connect(mapStateToProps)(withSearch(SearchAll))
